import { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectIsMobile } from 'src/common/selectors/app';
import { selectIsNowPlayingDialogOpen } from 'src/common/selectors/dialog';
import ClampText from '../../shared/ClampText';
import ImageWithDefault from '../../../components/shared/ImageWithDefault';
import Titles from '../shared/Titles';
import GuideItemLink from '../shared/GuideItemLink';
import PillButton from '../../shared/button/PillButton';
import { GO_TO_PROFILE_LABEL } from '../../../constants/localizations/button';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import css from './item-card.module.scss';

// exported for testing
export const ItemCard = (props) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const { guideItem = {}, index, isMobile, isNowPlayingDialogOpen } = props;

  if (!isMobile || !isNowPlayingDialogOpen) {
    return null;
  }

  const { title, subtitle, description, image, guideId } = guideItem;

  return (
    <div
      className={css.itemCardContainer}
      data-testid={`guideItem-${index}`}
      data-testtype="itemCard"
      data-nextguideitem={guideId}
    >
      <div className={css.topContainer}>
        <ImageWithDefault
          dataTestId="guideItemImage"
          src={image}
          alt={title}
          className={css.image}
        />
        <Titles
          title={title}
          subtitle={subtitle}
          titleMaxLineCount={2}
          subtitleMaxLineCount={1}
          titleClassName={css.title}
          subtitleClassName={css.subtitle}
        />
      </div>
      {description && (
        <ClampText clamp={3} className={css.description}>
          {description}
        </ClampText>
      )}
      <GuideItemLink guideItem={guideItem}>
        <PillButton
          className={css.button}
          id="goToProfileButton"
          label={getLocalizedText(GO_TO_PROFILE_LABEL)}
        />
      </GuideItemLink>
    </div>
  );
};

ItemCard.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isNowPlayingDialogOpen: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isMobile: selectIsMobile(state),
    isNowPlayingDialogOpen: selectIsNowPlayingDialogOpen(state),
  };
}

export default connect(mapStateToProps)(ItemCard);
